
import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Shield, Heart, ExternalLink } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="py-12 mt-auto">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
            className="space-y-4"
          >
            <Link to="/" className="flex items-center">
              <span className="font-display text-primary text-xl font-bold">pvt.bio</span>
            </Link>
            <p className="text-muted-foreground text-sm max-w-md">
              A privacy-first matrimonial biodata management system 
              that puts you in control of your personal information.
            </p>
            <div className="flex items-center gap-2 text-muted-foreground text-sm">
              <Shield size={14} />
              <span>Privacy-focused since 2023</span>
            </div>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            viewport={{ once: true }}
            className="space-y-4"
          >
            <h4 className="font-medium text-base">Quick Links</h4>
            <nav className="flex flex-col space-y-2">
              <Link to="/dashboard" className="text-muted-foreground hover:text-foreground text-sm transition-colors">
                Dashboard
              </Link>
              <Link to="/profile" className="text-muted-foreground hover:text-foreground text-sm transition-colors">
                Create Profile
              </Link>
              <Link to="/preview" className="text-muted-foreground hover:text-foreground text-sm transition-colors">
                Preview Profile
              </Link>
              <Link to="/" className="text-muted-foreground hover:text-foreground text-sm transition-colors">
                Privacy Policy
              </Link>
              <Link to="/" className="text-muted-foreground hover:text-foreground text-sm transition-colors">
                Terms of Service
              </Link>
            </nav>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            viewport={{ once: true }}
            className="space-y-4"
          >
            <h4 className="font-medium text-base">Contact</h4>
            <p className="text-muted-foreground text-sm">
              Have questions or need support?
            </p>
            <a 
              href="mailto:support@pvt.bio" 
              className="inline-flex items-center gap-1 text-primary hover:underline text-sm"
            >
              support@pvt.bio
              <ExternalLink size={12} />
            </a>
          </motion.div>
        </div>
        
        <div className="border-t border-border mt-12 pt-6 flex flex-col md:flex-row justify-between items-center">
          <p className="text-muted-foreground text-xs">
            © {new Date().getFullYear()} pvt.bio. All rights reserved.
          </p>
          <div className="flex items-center mt-4 md:mt-0">
            <span className="text-xs text-muted-foreground flex items-center gap-1">
              Made with <Heart size={12} className="text-primary" /> for privacy
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
